module.exports = __webpack_public_path__ + "img/1-instructions.e58c356a.webp";